<template>
  <div class="">
     <div class="searchBox" ref="searchBox">
        <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
          <div class="searchBox inpBox">
                <!-- <el-form-item label="订单编号:" prop="orderNo">
                  <el-input  placeholder="" v-model="searchFrom.orderNo"></el-input>
                </el-form-item> -->
                <el-form-item label="运单编号:" prop="wayNo">
                  <el-input  placeholder="" v-model="searchFrom.wayNo"></el-input>
                </el-form-item>
                <el-form-item label="司机姓名:" prop="dirverName">
                  <el-input  placeholder="" v-model="searchFrom.dirverName"></el-input>
                </el-form-item>
                <el-form-item label="车牌号:" prop="vhcNo">
                  <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
                </el-form-item>
                <el-form-item label="运单状态 :" prop="customerStatus">
                <el-select v-model="searchFrom.customerStatus" placeholder="请选择">
                  <el-option v-for="val in ydzt" :label="val.name" :value="val.val" :key="val.val"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="是否自动签收 :" prop="automaticSignIn">
                  <el-select v-model="searchFrom.automaticSignIn" placeholder="请选择">
                    <el-option v-for="val in zdqs" :label="val.name" :value="val.val" :key="val.val"></el-option>
                  </el-select>
                </el-form-item> -->
              <!-- <el-form-item label="审核状态:" prop="auditStatus">
                  <el-select  v-model="searchFrom.auditStatus"   placeholder="请选择">
                     <el-option label="全部" value=""></el-option>
                     <el-option label="待审核" value="0"></el-option>
                    <el-option label="审核通过" value="1"></el-option>
                    <el-option label="审核驳回" value="2"></el-option>
                    <el-option label="不审核" value="3"></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="装车量:" prop="weight" class="fanwei">
                  <el-input  placeholder="" v-number-input.float="3"  v-model="searchFrom.loadingWeightStart"></el-input>-
                  <el-input  placeholder="" v-number-input.float="3"  v-model="searchFrom.loadingWeightEnd"></el-input>
                </el-form-item>
                <el-form-item label="卸车量:" prop="weight" class="fanwei">
                  <el-input  placeholder="" v-number-input.float="3"  v-model="searchFrom.unloadingWeightStart"></el-input>-
                  <el-input  placeholder="" v-number-input.float="3"  v-model="searchFrom.unloadingWeightEnd"></el-input>
                </el-form-item>
                    <el-form-item label="接单时间:" prop="receivingTime">
                      <el-date-picker
                        v-model="searchFrom.receivingTime"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                     <el-form-item label="装车时间:" prop="outTime">
                      <el-date-picker
                        v-model="searchFrom.outTime"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                     <el-form-item label="到货时间:" prop="arrivalTime">
                      <el-date-picker
                        v-model="searchFrom.arrivalTime"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="签收时间:" prop="acceptanceTime">
                      <el-date-picker
                        v-model="searchFrom.acceptanceTime"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item> -->
          </div>

         <div class="searchBtnBox">
           <el-form-item btnCode="01J0010100"  v-if="btnFlg[0]">
              <el-button type="primary" @click="searchFn">查询</el-button>
            </el-form-item>
            <el-form-item btnCode="01J0010200"  v-if="btnFlg[1]">
              <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
            </el-form-item>
            <el-form-item btnCode="01J0010300"  v-if="btnFlg[2]">
              <el-button type="primary" :disabled="isDisable"  @click="daochuFN">导出</el-button>
            </el-form-item>
         </div>
        </el-form>
      </div>
    <div :style="{height:h}">
      <el-table
        :data="tableList"
        ref="table"
        v-loading="loading"
        bordersize="mini"
        class="table"
        height="100%"
        style="width: 100%"
        @row-click="handleRowClick"
        center
        border>
          <el-table-column type="selection" width="55" ></el-table-column>
          <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="操作"  width="140">
               <template slot-scope="scope">
                 <div>
                  <el-button type="text" size="mini"  v-if="(scope.row.customerStatus==2006||scope.row.customerStatus==2004||scope.row.customerStatus==2005)&&btnFlg[3]"
                    @click="lookGps(scope.row)">轨迹</el-button>
                  <el-button type="text" size="mini"  v-if="(scope.row.platformStatus!=2001&&scope.row.platformStatus!=2002)&&btnFlg[4]"  @click="pingzFn(scope.row)">凭证</el-button>
                  <el-button type="text" size="mini" v-if="(scope.row.customerStatus==2002||scope.row.customerStatus==2003)&&btnFlg[5]"  @click="lookGps(scope.row)">监控</el-button>
                  <!-- <el-button type="text" size="mini"  v-if="scope.row.customerStatus==2004&&btnFlg[4]"  @click="qianshouFn(scope.row)">签收</el-button>
                  <el-button type="text" size="mini"  v-if="(scope.row.customerStatus==2005||scope.row.customerStatus==2006)&&scope.row.evaluationStatus==0&&btnFlg[5]" @click="pingjiaFn(scope.row)">评价</el-button>
                  <el-button type="text" size="mini"  v-if="(scope.row.customerStatus==2005||scope.row.customerStatus==2006)&&(scope.row.evaluationStatus==1 || scope.row.driverEvaluationStatus==1)&&btnFlg[5]" @click="seePJFn(scope.row)">查看评价</el-button>
                  <el-button type="text" size="mini"  v-if="(scope.row.customerStatus==2005||scope.row.customerStatus==2006)&&btnFlg[6]"  @click="shouhouFn(scope.row)">售后</el-button>
                  <el-button type="text" size="mini"  v-if="(scope.row.customerStatus==2005||scope.row.customerStatus==2006)&&btnFlg[7]"  @click="jieSuanFn(scope.row)">结算明细</el-button>
                  <el-button type="text" size="mini" @click="unUsual(scope.row)" v-show="scope.row.abnormalState==1">异常</el-button> -->
                </div>
              </template>
          </el-table-column>
           <!-- <el-table-column property="orderNo" width="200" label="订单编号"></el-table-column> -->
          <el-table-column label="运单编号" width="200">
            <template slot-scope="scope">
              <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.wayNo}}</span>
            </template>
          </el-table-column>
           <!-- <el-table-column property="auditStatus" label="审核状态" width="100">
            <template scope="scope">
              <div>
                  <span v-if="scope.row.auditStatus==0 || scope.row.auditStatus==3">{{[ "待审核", "审核通过", "审核驳回" ,"不审核"][scope.row.auditStatus]}}</span>
                  <el-button type="text" size="mini" v-if="scope.row.auditStatus==1 || scope.row.auditStatus==2"  @click="recordClick(scope.row)">
                    <span style="color: #0c46a2;cursor: pointer;">{{[ "待审核", "审核通过", "审核驳回" ,"不审核"][scope.row.auditStatus]}}</span>
                  </el-button>
               </div>
            </template>
          </el-table-column> -->
          <el-table-column  width="90" property="customerStatus" :formatter="statusFormat" label="运单状态"></el-table-column>
          <el-table-column property="vhcNo" width="100" :formatter="emptyFn" label="车牌号"></el-table-column>
          <el-table-column property="dirverName" width="90" :formatter="emptyFn" label="司机姓名"></el-table-column>
          <el-table-column property="dirverMobile" width="120" :formatter="emptyFn" label="联系电话"></el-table-column>
          <el-table-column property="weight" width="120" :formatter="emptyFn" label="调度量"></el-table-column>
          <el-table-column property="loadingWeight" width="120" :formatter="emptyFn" label="装车量"></el-table-column>
          <el-table-column property="unloadingWeight" width="120" :formatter="emptyFn" label="卸车量"></el-table-column>
          <!-- 自动签收状态  1是 2否 -->
          <!-- <el-table-column  width="110" property="automaticSignIn" label="是否自动签收">
            <template scope="scope">
               <div>
                  <span v-show="scope.row.automaticSignIn==1">是</span>
                  <span v-show="scope.row.automaticSignIn==2">否</span>
               </div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column property="evaluationStatus" label="委托平台" width="90">
            <template scope="scope">
              {{[ "是", "否"][scope.row.commissionPlatform-1]}}
            </template>
          </el-table-column> -->
           <!-- <el-table-column property="evaluationStatus" label="评价状态" width="90">
            <template scope="scope">
              {{[ "未评价", "已评价"][scope.row.evaluationStatus]}}
            </template>
          </el-table-column> -->
         <el-table-column prop="receivingTime" width="170" :formatter="dateFormat"  label="接单时间"></el-table-column>
           <el-table-column prop="outTime" width="170" :formatter="dateFormat"  label="装车时间"></el-table-column>
          <el-table-column prop="arrivalTime" width="170" :formatter="dateFormat"  label="到货时间"></el-table-column>
           <!-- <el-table-column prop="signingTime" width="170" :formatter="dateFormat"  label="签收时间"></el-table-column> -->
        </el-table>
    </div>
      <!-- 分页 -->
      <div>
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[25,50,100]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 车辆监控-->
     <el-dialog  title="车辆监控"  :visible.sync="dialogVehM" width="1130px"  class="vehm" :fullscreen="true" :close-oni-click-modal="false" @close="closeMapDialog" :close-on-press-escape="false" center>
        <mapReal :map-data="mapData"  v-if="mapData.isShowMap==1"></mapReal>
        <maphistory :map-data="mapData" v-if="mapData.isShowMap==2"></maphistory>
     </el-dialog>
     <!-- 签收 -->
      <el-dialog  title="签收"  :visible.sync="dialogQS" width="400px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
         <el-form :inline="true" :rules="rules" :model="QSFrom" ref="QSFrom" class="demo-form-inline jiaoyan" label-width="70px" size="mini">
          <div class="inpBox" style="margin:0 auto;text-align:center">
                <!-- <el-form-item label="签收量:" prop="signingWeight">
                <el-input  placeholder="" maxlength="20"   v-model="QSFrom.signingWeight" ></el-input>
              </el-form-item> -->
              <el-radio-group v-model="radio" @change="xz">
                <el-radio :label="3">
                  <el-form-item label="装车量:" prop="loadingWeight">
                   <el-input  placeholder="" maxlength="20"  class="disabled" :readonly="true" v-model="QSFrom.loadingWeight" ></el-input>
                  </el-form-item>
                </el-radio>
                <el-radio :label="6" >
                  <el-form-item label="卸车量:" prop="unloadingWeight">
                   <el-input  placeholder="" maxlength="20"  class="disabled" :readonly="true" v-model="QSFrom.unloadingWeight" ></el-input>
                  </el-form-item>
                </el-radio>
                <el-radio :label="9" style="margin-right:30px">
                   <el-form-item label="自定义:" prop="zdy" >
                   <el-input  placeholder="" maxlength="20" v-model="QSFrom.zdy"  v-number-input.float="3"  v-on:input="zdyinput"  ></el-input>
                  </el-form-item>
                </el-radio>
              </el-radio-group>
              <span style="margin:0 auto;text-align:center;">签收量：<span style="color:red;font-weight:bold">{{QSFrom.signingWeight}}</span></span>
          </div>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogQS = false">取 消</el-button>
          <el-button type="primary" @click="QSsave('QSFrom')">确 定</el-button>
        </span>
     </el-dialog>
      <!-- 售后 -->
      <el-dialog  title="申请售后"  :visible.sync="dialogSH" width="460px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
         <el-form :inline="true" :rules="rules" :model="SHFrom" ref="SHFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
          <div class="inpBox">
              <el-form-item label="运单号:" prop="account">
                <span>{{SHFrom.wayNo}}</span>
              </el-form-item>
               <el-form-item label="联系电话:" prop="phone">
                  <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="SHFrom.phone"></el-input>
                </el-form-item>
              <el-form-item label="问题描述:" prop="complaintContent" class="miaoshu">
                <el-input  type="textarea" :rows="3"  placeholder=""  v-model="SHFrom.complaintContent"></el-input>
              </el-form-item>
          </div>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogSH = false">取 消</el-button>
          <el-button type="primary" @click="SHsave('SHFrom')">确 定</el-button>
        </span>
     </el-dialog>
      <!-- 评价 -->
      <el-dialog  title="评价"  :visible.sync="dialogPJ" width="460px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
         <el-form :inline="true" :rules="rules" :model="PJFrom" ref="PJFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
          <div class="inpBox">
              <!-- <el-form-item label="整体评价:" prop="overallEvaluation">
                <el-rate v-model="PJFrom.overallEvaluation" :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item label="运输时效:" prop="transportPrescription">
                <el-rate v-model="PJFrom.transportPrescription" :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item label="司机态度:" prop="attitude ">
                <el-rate v-model="PJFrom.attitude " :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item label="评价备注:" prop="remark" class="miaoshu">
                <el-input  type="textarea" :rows="3"  placeholder="" maxlength="100"  v-model="PJFrom.remark"></el-input>
              </el-form-item> -->
              <el-form-item label="接单及时性:" prop="orderTimely">
                <el-rate v-model="PJFrom.orderTimely" :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item label="到货及时性:" prop="arrivalTimely">
                <el-rate v-model="PJFrom.arrivalTimely" :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item label="运输安全性:" prop="transportSafety ">
                <el-rate v-model="PJFrom.transportSafety " :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item label="服务质量:" prop="serviceQuality" class="miaoshu">
                <el-rate v-model="PJFrom.serviceQuality" :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item label="总体满意度:" prop="overallEvaluation" class="miaoshu">
                <el-rate v-model="PJFrom.overallEvaluation " :colors="colors"></el-rate>
              </el-form-item>
              <el-form-item label="评价备注:" prop="remark" class="miaoshu">
                <el-input  type="textarea" :rows="3"  placeholder="" maxlength="100"  v-model="PJFrom.remark"></el-input>
              </el-form-item>
          </div>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogPJ = false">取 消</el-button>
          <el-button type="primary" @click="PJsave('PJFrom')">确 定</el-button>
        </span>
     </el-dialog>
      <!-- 结算明细 -->
      <el-dialog  title="结算明细"  :visible.sync="dialogJS" width="800px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
         <el-form :inline="true"  :model="ZFfrom" ref="ZFfrom" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
            <div>
              <el-form-item label="运单编号:"  class="jiage" prop="">
                <div style="width:260px">{{ZFfrom.businessNo}}</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item prop="" label="结算状态:">
                <div class="ZSbox" >
                    <span v-if="ZFfrom.settlementStatus==1301">未结算</span>
                    <span v-if="ZFfrom.settlementStatus==1303">已结算</span>
                </div>
              </el-form-item>
              <el-form-item label="结算金额:"  class="jiage" prop="">
                <span>{{ZFfrom.totalAmount}}元</span>
              </el-form-item>
              <el-form-item label="结算时间:"  class="jiage" prop="">
                <span>{{ZFfrom.settlementTime|dateFormat}}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item prop="" label="提现状态:">
                <div class="ZSbox" >{{['未提现','提现中','已提现'][ZFfrom.withdrawalStatus-1]}}</div>
              </el-form-item>
              <el-form-item label="提现金额:"  class="jiage" prop="">
                <span>{{ZFfrom.totalAmount}}元</span>
              </el-form-item>
              <el-form-item label="提现时间:"  class="jiage" prop="">
                <span>{{ZFfrom.withdrawalTime|dateFormat}}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item prop="" label="收款人:">
                <span>{{ZFfrom.settlementName}}</span>
              </el-form-item>
              <el-form-item label="收款人卡号:"  class="jiage" prop="" v-if="ZFfrom.withdrawalStatus==3">
                <span>{{ZFfrom.bankAccount}}</span>
              </el-form-item>
              <el-form-item v-if="ZFfrom.withdrawalStatus==3&&ZFfrom.isAutoWithdraw != 2">
               <el-button type="text" size="mini"   @click="huidanFn()">银行回单</el-button>
              </el-form-item>
            </div>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogJS = false">关闭</el-button>
        </span>
     </el-dialog>
       <!-- 运单详情 -->
      <el-dialog  title="运单详情"  :visible.sync="dialogXQ" width="1100px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
          <el-form :inline="true" ref="XQFrom" enctype="multipart/form-data" :model="goodform"   class="demo-form-inline" label-width="110px" size="mini">
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
              </h4>
              <div class="box1">
                  <div class="item">
                    <div class="box1T" style="color:#0c46a2"><i class="el-icon-location"></i>(发){{goodform.deliverCompany}}</div>
                    <div class="box1B"><span>{{goodform.deliverPerson}}</span><span>{{goodform.deliverPhone}}</span><span>{{goodform.deliverAddress}}</span></div>
                  </div>
                  <div class="item">
                    <div class="box1T" style="color:#F56C6C" > <i class="el-icon-location"></i>(收){{goodform.receivingCompany}}</div>
                    <div class="box1B"><span>{{goodform.receivingPerson}}</span><span>{{goodform.receivingPhone}}</span><span>{{goodform.receivingAddress}}</span></div>
                  </div>
              </div>
               <hr>
            </div>
             <div class="addressBox">
              <h4 class="title">
                  <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
                </h4>
                <div>
              <el-form-item label="货物类型:"  class="jiage" prop="productType">
                <span>{{goodform.productTypeName}}</span>
              </el-form-item>
               <el-form-item label="调度量:"  class="jiage" prop="weight">
                <span>{{goodform.weight}}</span><span class="">{{goodform.unitMeasurement}}</span>
              </el-form-item>
             <el-form-item label="装车量:"  class="jiage" prop="weight">
                <span>{{goodform.loadingWeight}}</span><span class="">{{goodform.unitMeasurement}}</span>
              </el-form-item>
              <el-form-item label="卸车量:"  class="jiage" prop="weight">
                <span>{{goodform.unloadingWeight}}</span><span class="">{{goodform.unitMeasurement}}</span>
              </el-form-item>
              </div>
              <hr>
            </div>
            <div class="addressBox" v-if="goodform.goodList">
              <h4 class="title">
                  <span><i class="fa fa-bars iconFont" aria-hidden="true"></i>货物明细</span>
                </h4>
                <div>
                  <el-table :data="goodform.goodList" ref="detailTable"    bordersize="mini" class="table" height="300"  style="width: 100%" center border >
                    <el-table-column type="index" width="55" label="序号"></el-table-column>
                    <el-table-column property="cargoBarcode" width="160"   label="捆包号"></el-table-column>
                    <el-table-column property="productName" :formatter="emptyFn" label="品名"></el-table-column>
                    <el-table-column property="brand" width="120" :formatter="emptyFn" label="牌号"></el-table-column>
                    <el-table-column property="specification" width="140" :formatter="emptyFn"  :show-overflow-tooltip="true" label="规格"></el-table-column>
                    <el-table-column property="model" width="120" label="材质"></el-table-column>
                    <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
                    <el-table-column property="position" width="100"  :formatter="emptyFn" label="库位"></el-table-column>
                </el-table>
              </div>
              <hr>
            </div>
            <div class="addressBox">
              <h4 class="title">
                  <span><i class="fa fa-truck iconFont" aria-hidden="true"></i>承运信息</span>
                </h4>
                <div>
              <el-form-item label="车牌号:"  class="jiage" prop="productType">
                <span>{{goodform.vhcNo}}</span>
              </el-form-item>
              <el-form-item label="司机姓名:"  class="jiage" prop="weight">
                <span>{{goodform.dirverName}}</span><span class=""></span>
              </el-form-item>
             <!-- <el-form-item label="联系电话:"  class="jiage" prop="weight">
                <span>{{goodform.dirverMobile}}</span><span class=""></span>
              </el-form-item> -->
              </div>
              <hr>
            </div>
             <div class="addressBox">
              <h4 class="title">
                  <span><i class="fa fa-clock-o iconFont" aria-hidden="true"></i>时间记录</span>
                </h4>
                <div>
                  <div>
                      <el-form-item label="发布时间:" prop="createTime">
                          <el-date-picker
                            v-model="goodform.createTime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="timestamp"
                            type="datetime"
                            :readonly="true"
                              placeholder=""
                          ></el-date-picker>
                    </el-form-item>
                      <!-- <el-form-item label="发布人:"  class="jiage" prop="createUserName">
                      <span>{{goodform.createUserName}}</span>
                    </el-form-item> -->
                  </div>
                  <!-- <div v-if="goodform.receivingTime">
                     <el-form-item label="接单时间:" prop="receivingTime">
                          <el-date-picker
                            v-model="goodform.receivingTime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="timestamp"
                            type="datetime"
                            :readonly="true"
                              placeholder=""
                          ></el-date-picker>
                    </el-form-item>
                  </div> -->
                  <div  v-if="goodform.outTime">
                     <el-form-item label="装车时间:" prop="outTime">
                          <el-date-picker
                            v-model="goodform.outTime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="timestamp"
                            type="datetime"
                            :readonly="true"
                              placeholder=""
                          ></el-date-picker>
                    </el-form-item>
                  </div>
                  <div  v-if="goodform.arrivalTime">
                     <el-form-item label="到货时间:" prop="arrivalTime">
                          <el-date-picker
                            v-model="goodform.arrivalTime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="timestamp"
                            type="datetime"
                            :readonly="true"
                              placeholder=""
                          ></el-date-picker>
                    </el-form-item>
                  </div>
                  <div  v-if="goodform.signingTime">
                     <el-form-item label="签收时间:" prop="signingTime">
                          <el-date-picker
                            v-model="goodform.signingTime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="timestamp"
                            type="datetime"
                            :readonly="true"
                              placeholder=""
                          ></el-date-picker>
                    </el-form-item>
                  </div>
                  <div  v-if="goodform.evaluateTime">
                     <el-form-item label="评价时间:" prop="evaluateTime">
                          <el-date-picker
                            v-model="goodform.evaluateTime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="timestamp"
                            type="datetime"
                            :readonly="true"
                              placeholder=""
                          ></el-date-picker>
                    </el-form-item>
                  </div>
              </div>
              <hr>
            </div>
            <div class="addressBox" v-if="goodform.isChangeCar==1">
              <h4 class="title">
                  <span><i class="fa fa-truck iconFont" aria-hidden="true"></i>换车记录</span>
                </h4>
                <div>
              <div>
                <el-form-item label="原车牌号:"  class="jiage" prop="productType">
                  <span>{{goodform.carLogList[0].vhcNo}}</span>
                </el-form-item>
                <el-form-item label="原司机姓名:"  class="jiage" prop="weight">
                  <span>{{goodform.carLogList[0].driverName}}</span><span class=""></span>
                </el-form-item>
                <!-- <el-form-item label="原联系电话:"  class="jiage" prop="weight">
                  <span>{{goodform.carLogList[0].dirverMobile}}</span><span class=""></span>
                </el-form-item> -->
              </div>
              <div>
                <el-form-item label="现车牌号:"  class="jiage" prop="productType">
                  <span>{{goodform.carLogList[0].currentVhcNo}}</span>
                </el-form-item>
                <el-form-item label="现司机姓名:"  class="jiage" prop="weight">
                  <span>{{goodform.carLogList[0].currentDirverName}}</span><span class=""></span>
                </el-form-item>
                <!-- <el-form-item label="现联系电话:"  class="jiage" prop="weight">
                  <span>{{goodform.carLogList[0].currentDirverMobile}}</span><span class=""></span>
                </el-form-item> -->
                <el-form-item label="换车时间:" prop="">
                          <el-date-picker
                            v-model="goodform.carLogList[0].endTime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="timestamp"
                            type="datetime"
                            :readonly="true"
                              placeholder=""
                          ></el-date-picker>
                    </el-form-item>
              </div>
              </div>
            </div>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogXQ = false">取 消</el-button>
        </span>
     </el-dialog>
     <!-- 凭证 -->
      <lookVoucher  :row-data="row" v-if="zujianFlag" @destroy="destroy"></lookVoucher>
       <!-- 审核记录 -->
      <shenheJilu  :row-data="row" v-if="shenheJiluFlag" @destroy="destroy"></shenheJilu>
      <!-- 异常记录 -->
      <UnUsual v-if="recordMark" :recordMark.sync="recordMark" :rowData='rowData'/>
      <!-- 查看评价 -->
      <el-dialog  title="查看评价"  :visible.sync="dialogSeePJ" width="500px"  :close-oni-click-modal="false" @close="seePJClose" :close-on-press-escape="false" center>
        <el-form :inline="true" :rules="rules" :model="PJSeeFrom" ref="PJSeeFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
          <div class="inpBox">
            <el-form-item label="接单及时性:" prop="orderTimely">
              <el-rate v-model="PJSeeFrom.orderTimely" :colors="colors" disabled></el-rate>
            </el-form-item>
            <el-form-item label="到货及时性:" prop="arrivalTimely">
              <el-rate v-model="PJSeeFrom.arrivalTimely" :colors="colors" disabled></el-rate>
            </el-form-item>
            <el-form-item label="运输安全性:" prop="transportSafety ">
              <el-rate v-model="PJSeeFrom.transportSafety " :colors="colors" disabled></el-rate>
            </el-form-item>
            <el-form-item label="服务质量:" prop="serviceQuality" class="miaoshu">
              <el-rate v-model="PJSeeFrom.serviceQuality" :colors="colors" disabled></el-rate>
            </el-form-item>
            <el-form-item label="总体满意度:" prop="overallEvaluation" class="miaoshu">
              <el-rate v-model="PJSeeFrom.overallEvaluation " :colors="colors" disabled></el-rate>
            </el-form-item>
            <el-form-item label="评价备注:" prop="remark" class="miaoshu">
              <el-input  type="textarea" :rows="3"  placeholder="" maxlength="100" disabled v-model="PJSeeFrom.remark"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="seePJClose">取 消</el-button>
        </span>
     </el-dialog>
    </div>
  </template>

<script>
import { getBtn } from '@/utils/getButton'
import { wayList, waySignForWay, evaluateAdd, sWayAfterSalesAdd, wayDetail, socUpSettlementDetail, evaluateList } from '@/api/soc-customer'
import mapReal from '@/components/mapreal.vue'
import maphistory from '@/components/maphistory.vue'
import { emptyFn } from '@/utils/util'
import lookVoucher from '@/components/networkFreight/lookVoucher.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import shenheJilu from '@/components/networkFreight/shenheJilu.vue'
export default {
  data () {
    return {
      radio: '',
      emptyFn: emptyFn,
      h: 500,
      dialogVehM: false,
      dialogQS: false,
      QSFrom: {},
      dialogSH: false,
      SHFrom: {
      },
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        payCustomerName: '' // 付款客户名称 赋值为租户名称
      },
      total: 0,
      dialogJS: false,
      ZFfrom: {},
      ydzt: [
        { val: '', name: '请选择' },
        { val: 2002, name: '已接单' },
        { val: 2003, name: '运输中' },
        { val: 2004, name: '待签收' },
        { val: 2005, name: '已签收' }
      ],
      zdqs: [
        { val: '', name: '请选择' },
        { val: 1, name: '是' },
        { val: 2, name: '否' }
      ],
      dialogPJ: false,
      PJFrom: {},
      dialogXQ: false,
      XQFrom: {},
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      mapData: '',
      loading: false,
      zujianFlag: false, // 凭证
      shenheJiluFlag: false, // 审核记录
      rules: {
        // signingWeight: [
        //   { required: true, message: '请输入签收重量', trigger: 'blur' }
        // ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        complaintContent: [
          { required: true, message: '请输入问题描述', trigger: 'blur' }
        ]
      },
      tableList: [],
      goodform: {},
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['01J0010100', '01J0010200', '01J0010300', '01J0010400', '01J0010500', '01J0010600'],
      rowData: {},
      recordMark: false,
      dialogSeePJ: false,
      PJSeeFrom: {},
      seePJId: '',
      tabIndex: 1
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/waybillAdministrate')
    this.searchFrom.payCustomerName = localStorage.getItem('tenantName')
    if (this.searchFrom.payCustomerName) {
      this.getList(this.searchFrom)
    } else {
      this.tableList = []
    }
  },
  watch: {

  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 异常
    unUsual (row) {
      this.rowData.wayNo = row.wayNo
      this.rowData.dirverName = row.dirverName
      this.rowData.dirverMobile = row.dirverMobile
      this.rowData.vhcNo = row.vhcNo
      this.rowData.id = row.id
      this.recordMark = true
    },
    // 银行回单
    huidanFn () {
      // let url = this.global.ZXpingzheng + 'subAccNo=' + this.ZFfrom.platformZxAccNo + '&printVerifyCode=' + this.ZFfrom.printVerifyCode
      // console.log(url)
      // window.open(url)
      if (this.global.ZXpingzheng != null && this.ZFfrom.platformZxAccNo != null) {
        let url = this.global.ZXpingzheng + 'subAccNo=' + this.ZFfrom.platformZxAccNo + '&printVerifyCode=' + this.ZFfrom.printVerifyCode
        console.log(url)
        window.open(url)
      } else {
        this.$alert('暂未产生银行回单，请稍后查询！', '系统提示')
      }
    },
    // 导出
    daochuFN () {
      if (this.searchFrom.acceptanceTime) {
        exportExcel(
          this.global.orderName + '/way/exportSocWayList',
          this.searchFrom,
          '运单列表'
        )
        this.isDisable = true
        setTimeout(() => {
          this.isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
      } else {
        this.$alert('请选择签收时间', '系统提示')
      }
    },
    // 结算明细
    jieSuanFn (row) {
      socUpSettlementDetail({ wayNo: row.wayNo }).then(res => {
        this.dialogJS = true
        this.ZFfrom = res.tDownstreamSettlement
        this.ZFfrom.platformZxAccNo = res.platformZxAccNo
        this.ZFfrom.printVerifyCode = res.printVerifyCode
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 运单详情
    detailFn (row) {
      this.dialogXQ = true
      wayDetail({ businessNo: row.wayNo }).then(res => {
        this.goodform = res
      })
    },
    // 评价
    pingjiaFn (row) {
      this.dialogPJ = true
      this.PJFrom.wayId = row.id
    },
    PJsave () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      evaluateAdd(this.PJFrom).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.dialogPJ = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 售后
    shouhouFn (row) {
      this.dialogSH = true
      this.SHFrom.wayNo = row.wayNo
      this.SHFrom.wayId = row.id
    },
    SHsave () {
      this.$refs.SHFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sWayAfterSalesAdd(this.SHFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.dialogSH = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 签收
    qianshouFn (row) {
      this.dialogQS = true
      this.$set(this.QSFrom, 'loadingWeight', row.loadingWeight)
      this.$set(this.QSFrom, 'unloadingWeight', row.unloadingWeight)
      this.QSFrom.id = row.id
      this.row = row
    },
    xz () {
      if (this.radio == 3 && this.QSFrom.loadingWeight) {
        this.$set(this.QSFrom, 'signingWeight', this.QSFrom.loadingWeight)
        if (this.QSFrom.zdy) {
          this.$set(this.QSFrom, 'zdy', '')
        }
      } else if (this.radio == 6 && this.QSFrom.unloadingWeight) {
        this.$set(this.QSFrom, 'signingWeight', this.QSFrom.unloadingWeight)
        if (this.QSFrom.zdy) {
          this.$set(this.QSFrom, 'zdy', '')
        }
      } else if (this.radio == 9) {
        if (this.QSFrom.zdy) {
          this.$set(this.QSFrom, 'signingWeight', this.QSFrom.zdy)
        } else {
          this.$set(this.QSFrom, 'signingWeight', '')
        }
      }
    },
    zdyinput () {
      if (this.QSFrom.zdy && this.radio == 9) {
        this.$set(this.QSFrom, 'signingWeight', this.QSFrom.zdy)
      } else if (!this.QSFrom.zdy && this.radio == 9) {
        this.$set(this.QSFrom, 'signingWeight', '')
      }
    },
    QSsave () {
      if (this.radio == '' || !this.QSFrom.signingWeight) {
        this.$alert('请选择一项数据!', '系统提示')
        return
      }
      if (this.QSFrom.signingWeight == 0) {
        this.$alert('签收量不能为0!', '系统提示')
        return
      }
      this.$refs.QSFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          waySignForWay(this.QSFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.dialogQS = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 凭证
    pingzFn (row) {
      this.row = row
      this.zujianFlag = true
    },
    // 审核记录
    recordClick (row) {
      this.row = row
      this.shenheJiluFlag = true
    },
    // 组件销毁
    destroy () {
      this.zujianFlag = false
      this.shenheJiluFlag = false
    },
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 获取货物列表
    getList (searchFrom) {
      this.loading = true
      wayList(searchFrom).then(res => {
        this.tableList = res.list
        this.loading = false
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 查看定位
    lookGps (row) {
      this.dialogVehM = true
      this.mapData = row
      if (this.mapData.customerStatus == 2001 || this.mapData.customerStatus == 2002 || this.mapData.platformStatus == 2003) {
        this.mapData.isShowMap = 1
      } else {
        this.mapData.isShowMap = 2
      }
      this.mapData.type = 3
    },
    // 地图模态框关闭
    closeMapDialog () {
      this.mapData.isShowMap = 0
    },
    closeDialog () {
      this.radio = ''
      this.QSFrom = {}
      this.SHFrom = {}
      this.PJFrom = {}
      if (this.$refs.SHFrom) { this.$refs.SHFrom.clearValidate() }
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 2001:
          return '待运输'
        case 2002:
          return '已接单'
        case 2003:
          return '运输中'
        case 2004:
          return '待签收'
        case 2005:
          return '已签收'
        case 2006:
          return '已结算'
      }
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        hopeReceivingDate: null,
        transportEndOperateDate: null,
        createTime: null,
        payCustomerName: localStorage.getItem('tenantName')
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
      t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 查看评价
    seePJFn (row) {
      // type  1货主  2司机 整型
      this.tabIndex = 1
      this.dialogSeePJ = true
      this.seePJId = row.id
      this.evaluateList(this.seePJId, this.tabIndex)
    },
    evaluateList (wayId, type) {
      evaluateList({
        wayId: wayId,
        type: type
      }).then(res => {
        this.PJSeeFrom = res
      }).catch(error => {
        this.message.error(error.message)
      })
    },
    seePJClose () {
      this.dialogSeePJ = false
      this.tabIndex = 1
    }
  },
  components: {
    mapReal,
    maphistory,
    lookVoucher,
    shenheJilu
  }
}
</script>

  <style scoped lang='less'>
  .searchBox{
    display: flex;
  }
  .searchBox .el-date-editor{
        width: 350px!important;
  }
  .gjhBox{
        flex-shrink: 0;
  }
  .gjhBox /deep/.el-textarea__inner{
    width:150px;
  }

  /deep/.el-input.is-disabled .el-input__inner{
      border: none;
      background-color: #dcedff;
      color: #606266;
  }
  .dialogtnBox{
    display: flex;
    justify-content: space-between;
    /deep/.el-form-item--mini.el-form-item{
          margin-bottom: 15px!important;
    }

  }
  .box1 span{
    margin-left: 10px;
    font-size: 12px;
  }
  .imgBox{
    margin: 22px 10px;
    ul{
      display: flex;
      padding-left: 0;
      li{
           width: 160px;
      height: 160px;
      list-style: none;
      margin-right: 10px;
        img{
          width:100%;
          height:100%
        }
      }
    }
  }
  .detail  /deep/.el-input__inner{
    border:none;
    padding: 0;
  }
  .hidden /deep/.el-upload--picture-card{
    display: none;
  }
  .detail  /deep/.el-form-item--mini.el-form-item{
      margin-bottom: 0px;
  }
  .hidden /deep/.el-upload--picture-card{
    display: none;
  }

  /deep/.el-input.is-disabled .el-input__inner{
    background: #fff;
  }

   .danwei{
     /deep/ .el-input__inner{
           width: 300px;
      overflow: auto;
     }
   }
  .box1{
    display: flex;
    padding-left: 20px;
    .item{
      max-width: 48%;
      margin-left: 10px;
      font-size: 14px;
    }
    .box1T{
      margin-bottom: 10px;
      font-weight: bold;
    }
    .box1B{
      display: flex;
      flex-wrap: wrap;
      span{
        margin-right: 20px;
        line-height: 26px;
      }
    }
  }
  /deep/.el-dialog__body .el-date-editor .el-input__inner{
    border:none;
  }

   .addressBox /deep/.el-input__suffix,.addressBox /deep/.el-input__icon{
     display: none;
   }
  /deep/.miaoshu .el-textarea__inner{
    width: 260px;
  }
  /deep/.el-rate__icon{
    font-size: 30px;
  }

  .imgBox{
    margin: 22px 10px;
    ul{
      display: flex;
      padding-left: 0;
      li{
           width: 160px;
      height: 160px;
      list-style: none;
      margin-right: 10px;
        img{
          width:100%;
          height:100%
        }
      }
    }
  }
  .detail   /deep/.el-input__inner{
    border:none;
    padding: 0;
  }
  .hidden /deep/.el-upload--picture-card{
    display: none;
  }
  /deep/.el-input.is-disabled .el-input__inner{
    background: #fff;
  }
   /deep/.el-input__suffix, /deep/.el-input__icon{
     display: none;
   }
   .inpBox {
    display: flex;
    flex-wrap: wrap;
  }
  /deep/.el-form-item{
    flex-shrink: 0;
  }
  /deep/.fanwei{
     display: flex;
   .el-form-item__content{
   display: flex;
   }
    .el-input__inner{
      width: 100px;
    }
  }
  /deep/.el-radio__input {
    line-height: 2;
  }
  </style>
